import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

import { useDispatch, useSelector } from "react-redux";
import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import {
  ChildCategoryList,
  DeleteChildCategory,
  ChildCategoryChangeStatus,
} from "../../../redux/services/ChildcategoriesService/Child_categories.Services";
import Pagination from "../../../common/Pagination";
import Swal from "sweetalert2";
function ChaildCategoriesList() {
  const dispatch = useDispatch();
  const [totalRecords, setTotalRecords] = useState(0);
  const [categories, setCategories] = useState([]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const refreshData = useSelector((state) => state.productModal.refreshData);
  const [loading, setLoading] = useState(false);
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const payload = {
        page,
        search,
        limit,
        status,
      };
      const res = await ChildCategoryList(payload);
      setCategories(res?.data || []);
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [page, search, status, refreshData]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Child Categories List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Child  Categories </span>
              </nav>
            </div>
          </div>

          <button
            className="add-btn"
            onClick={() =>
              dispatch(
                openProductModal({
                  type: "create-child-category",
                  title: "Create Child Category",
                  data: {
                    refreshData: fetchCategories,
                  },
                }),
              )
            }
          >
            + Add Child Category
          </button>
        </div>
      </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Child Category..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Name</th>
                  <th>Vendor Name</th>
                  {/* <th>Status</th> */}
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {categories.length > 0 ? (
                  categories.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1 + (page - 1) * limit}</td>
                      <td>{item?.name}</td>
                      <td>
                        {item?.vendor_details?.name ||
                          item?.vendor_details?.mobile ||
                          "-"}
                      </td>
                      {/* <td>{item.status === 1 ? "Active" : "Inactive"}</td> */}
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item._id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status: item.status ? "Active" : "Inactive",
                                    statusFunction: ChildCategoryChangeStatus,
                                    onSuccess: fetchCategories,
                                  },
                                })
                              )
                            }
                          />

                          <label
                            htmlFor={`status-${item._id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>

                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>

                        </div>
                      </td>



                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <button
                            className="st-action-btn st-view-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "view-child-category",
                                  title: "View Child Category",
                                  data: item,
                                })
                              )
                            }
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "edit-child-category",
                                  title: "Edit Child Category",
                                  data: {
                                    ...item,
                                    refreshData: fetchCategories,
                                  },
                                })
                              )
                            }
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-child-category",
                                  title: "Delete Child Category",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteChildCategory,
                                    refreshData: fetchCategories,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-5">
                      <h5 className="mb-0">No Data Found</h5>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChaildCategoriesList;
